/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Sortorder1Inputs */

const en_entity_sortorder1 = /** @type {(inputs: Entity_Sortorder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sort Order`)
};

const de_entity_sortorder1 = /** @type {(inputs: Entity_Sortorder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reihenfolge`)
};

/**
* | output |
* | --- |
* | "Sort Order" |
*
* @param {Entity_Sortorder1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_sortorder1 = /** @type {((inputs?: Entity_Sortorder1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Sortorder1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_sortorder1(inputs)
	return de_entity_sortorder1(inputs)
});
export { entity_sortorder1 as "entity_sortOrder" }